import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPan = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 72 72",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m41.7659 13.7375c-.284-1.9293 1.0499-3.7236 2.9792-4.0075 1.9293-.284 3.7236 1.0498 4.0075 2.9792.0455.3093.0498.6232.0126.9336l.2571 18.9983-.0048.9513-.1928-9.6253c-.284-1.9293 1.0499-3.7236 2.9792-4.0075s3.7236 1.0498 4.0075 2.9792c.0455.3093.0498.6232.0126.9336l.176 12.9987-.0526 10.0853c-.4248 8.3102-7.7519 13.6293-16.06 13.2046-4.7918-.2654-9.32-2.2781-12.7278-5.6572-2.9178-3.0904-10.0856-11.5348-10.0856-11.5348-1.4629-2.1582-.3282-5.4939.8007-4.6726l9.8756 4.6509.0389-5.3996-.0389 5.3996.0389-5.3996-.0395-21.8505c-.284-1.9293 1.0499-3.7236 2.9792-4.0075s3.7236 1.0498 4.0075 2.9792c.0455.3093.0498.6232.0126.9336l.0947 6.9994.1861 10.6365-.3671-22.1928c-.284-1.9293 1.0499-3.7236 2.9792-4.0075 1.9293-.284 3.7236 1.0498 4.0075 2.9792.0455.3093.0498.6232.0126.9336l.1758 20.4538",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})
});
export default SvgPan;
